const shop = {
    "LBL_PAGE_TITLE":"Магазин",
    "LBL_TAB_INDIVIDUAL":"Индивидуальные",
    "LBL_TAB_GROUP":"Групповые",
    "LBL_TAB_MASTER_LESSONS":"Мастер-уроки",
    "BTN_MAKE_ORDER":"Купить",
    "LBL_LECTIE_PRICE":"лекцию",
    "LBL_DISCOUNT_VALUE":"Скидка",
    "LBL_POPUP_TITLE":"Оплата товара",
    "LBL_POPUP_PRODUCT":"Абонемент {count} лекций | Абонемент {count} лекция| Абонемент {count} лекции | Абонемент {count} лекций",
    "LBL_POPUP_DISCOUNT":"Скидка {discount} %",
    "LBL_POPUP_TOTAL":"Всего",
    "LBL_POPUP_PAYMENT_METHOD":"Способ оплаты",
    "LBL_POPUP_HELPER":"La selectarea metodei de plăți “Card Bancar” veți fi taxat în Lei Moldovenești (MDL).",
    "LBL_PAYMENT_METHOD_CARD":"Банковская карта",
    "LBL_PAYMENT_METHOD_PAYPAL":"PayPal",
    "LBL_CART_PAGE_TITLE":"Корзина товаров",
    "LBL_PAYMENT_SUCCESS_TITLE":"Транзакция выполнена!",
    "LBL_PAYMENT_SUCCESS_DESCRIPTION":"Большое спасибо за покупку! <br/> Менеджер Академии свяжется с вами в ближайшее время!",
    "LBL_PAYMENT_TRANSACTION_ID":"Транзакция",
    "LBL_PAYMENT_TRANSACTION_DATE":"Дата",
    "LBL_PAYMENT_TRANSACTION_TOTAL":"Всего",
    "LBL_PAYMENT_FAILURE_TITLE":"Операция ",
    "LBL_PAYMENT_FAILURE_BUTTON":"Попробуйте снова",
    "LBL_ENTER_PROMOCODE":"Укажите промокод",
    "LBL_LEVEL_1":"Pentru începători",
    "LBL_LEVEL_1_DESCRIPTION":"Regulile de joc, combinațiile elementare debutul, jocul de mijloc, finalurile simple",
    "LBL_LEVEL_2":"Pentru avansați",
    "LBL_LEVEL_1_DESCRIPTION":"Jocul strategic, lupta pentru centru, tipurile de atac și apărare, avantajul pozițional",
    "LBL_LEVEL_3":"Pentru avansați",
    "LBL_LEVEL_1_DESCRIPTION":"Jocul strategic, lupta pentru centru, tipurile de atac și apărare, avantajul pozițional",
};
export default shop